module.exports = __webpack_public_path__ + "static/durham-9b1e5eaa492eee6e9580d28dfec383cc.png";